export const contactLanguages = [
  {
    id: 1,
    name: 'Russian'
  },
  {
    id: 2,
    name: 'English'
  }
]



// WEBPACK FOOTER //
// ./src/constants/languages.js